<template>
  <div class="modal profile-modal" tabindex="-1" role="dialog">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Profile</h5>
          <button
            type="button"
            class="modal__close close"
            data-dismiss="modal"
            aria-label="Close"
            @click="$emit('closeModal')"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <div v-if="quotaShow.quotaUsed === 0" class="quota-text quota-empty">
            Calculating quota status. This may take a few minutes.
          </div>
          <div v-else class="quota-text">
            <span class="quota-used">{{ parseFloat(quotaShow.quotaUsed).toFixed(2) }} GB</span>
            used of {{ quotaShow.quotaMax }} GB
          </div>
          <div class="quota-chart">
            <svg viewBox="0 0 36 36" class="circular-chart green">
              <path
                class="circle-bg"
                d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"
              />
              <path
                class="circle"
                :class="{ animate: quotaShow.quotaUsed !== 0 }"
                :stroke-dasharray="percentage + ', 100'"
                d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"
              />
              <text x="18" y="20.35" class="percentage">{{ percentage }}%</text>
            </svg>
          </div>
          <button class="btn btn-primary float-right" data-dismiss="modal" @click="$emit('closeModal')">OK</button>
        </div>
        <div class="modal-footer"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { getValidImagesAndInstances } from '@/lib/api'

export default {
  props: {
    quota: {
      type: Object,
      default: {},
    },
  },
  computed: {
    quotaShow() {
      console.log('thequotainitial', this.quota)
      return this.quota.hasOwnProperty('quotaUsed') ? this.quota : { quotaUsed: 0, quotaMax: 0 }
    },
    percentage() {
      const { quotaUsed, quotaMax } = this.quotaShow
      const percentage = parseFloat((quotaUsed / quotaMax) * 100).toFixed(1)
      return isNaN(percentage) ? 0 : percentage
    },
  },
}
</script>

<style lang="scss" scoped>
@import '~@/styles/globals';
.quota-text {
  font-family: NotesEsa;
  font-weight: bold;
  letter-spacing: 1.2;
  font-size: 16px;
  &.quota-empty {
    font-weight: normal;
  }
  .quota-used {
    color: $pure-teal;
  }
}
.circular-chart {
  display: block;
  margin: 10px auto;
  max-height: 300px;
}
.circle-bg {
  fill: none;
  stroke: #eee;
  stroke-width: 3.8;
}

.circle {
  fill: none;
  stroke-width: 2.8;
  stroke-linecap: round;
}
.animate {
  animation: progress 1s ease-out forwards;
}
@keyframes progress {
  0% {
    stroke-dasharray: 0 100;
  }
}

.circular-chart.green .circle {
  stroke: $pure-teal;
}

.percentage {
  fill: $primary;
  font-family: sans-serif;
  font-size: 0.5em;
  text-anchor: middle;
}
</style>
